import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Star12 } from '../components/Star/Star12';
import { Star16 } from '../components/Star/Star16';
import { EStarSize, EStarTheme } from '../types/star';
export var STAR_SIZE_MAP = _defineProperty(_defineProperty({}, EStarSize.S, Star12), EStarSize.M, Star16);
export var STAR_FILL_MAP = _defineProperty(_defineProperty({}, EStarTheme.Filled, 'var(--decorative-orange)'), EStarTheme.NotFilled, '#ced1d7');